import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'
import { ReturnRefundLegStatusEnum } from './ReturnRefundLegStatusEnum'

/**
 * One actual-refund execution leg against a single source order payment. Legs are seeded Pending on
 * confirm and flipped to Refunded/Failed as the gateway call for each runs; the leg amounts across a
 * return sum to its refund total (gross).
 */
@ObjectType()
@InputType('ReturnRefundLegInput')
export class ReturnRefundLeg {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('rrl') })
  _id: string

  /**
   * The source order Payment._id this leg refunds.
   */
  @Field(() => String)
  @Prop({ type: String })
  sourcePaymentId: string

  @Field(() => Float)
  @Prop({ type: Number })
  amount: number

  /**
   * The gateway refund id (Stripe `re_…`); empty until the gateway call succeeds.
   */
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  refundId?: string

  @Field(() => ReturnRefundLegStatusEnum)
  @Prop({ type: String, enum: ReturnRefundLegStatusEnum })
  status: ReturnRefundLegStatusEnum

  /**
   * Gateway error message for failed legs; cleared when a retry succeeds.
   */
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  error?: string

  /**
   * Leg execution time (success or failure).
   */
  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  date?: Date
}
